import { isNullOrEmptyOrUndefined } from '@onyx/utils/typescript';

export const errorToObject = (err: Error) => {
  if (!(err instanceof Error)) {
    return {};
  }

  return Object.getOwnPropertyNames(err).reduce(
    (obj: Record<string, string | number>, key) => {
      const value = (err as unknown as Record<string, string | number>)[key];
      if (isNullOrEmptyOrUndefined(value)) {
        return obj;
      }
      return {
        ...obj,
        [key]: ['string', 'number', 'boolean'].includes(typeof value)
          ? value
          : value.toString(),
      };
    },
    {
      name: err.constructor.name || err.name || 'UnknownError',
      message: err.message || 'Unknown error',
      stack: err.stack || 'not available',
    }
  );
};
